import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'componentsV2/Hero/components/Overlay';
import HeroBackground from 'componentsV2/Hero/components/HeroBackground';
import ActionButtons from 'componentsV2/ActionButtons';
import Modal from 'componentsV2/Hero/components/Modal';
import ContextPlayer from 'components/ContextPlayer';
import Description from 'componentsV2/Hero/components/SeriesDescription';
import Headline from 'componentsV2/Headline';
import Logo from 'componentsV2/Logo';
import Favorite from 'components/Favorite';
import Metadata from 'componentsV2/Hero/components/Metadata';
import ProgressBar from 'componentsV2/ProgressBar';
import { SeriesProcessor } from '../../processors';
import style from './SeriesView.module.scss';

const Series = ({
  account,
  analytics,
  bookmarks,
  continueWatchingItems,
  disableScroll = () => {},
  favoriteProps,
  item,
}) => {
  const [playerVisibility, setPlayerVisibility] = useState(false);
  const [showModal, toggleModal] = useState(false);
  const {
    backgroundProps,
    buttonArray,
    descriptionProps,
    favoriteData,
    logoProps,
    metaData,
    playerProps,
    progressProps,
    title,
  } = SeriesProcessor({
    additionalFunctions: { setPlayerVisibility, disableScroll },
    analytics,
    bookmarks,
    continueWatchingItems,
    favoriteProps,
    panel: item,
    playerVisibility,
  });

  return (
    <>
      <ContextPlayer
        {...playerProps}
        account={account}
        theme={style}
        visibility={playerVisibility}
      />
      <Modal
        {...descriptionProps}
        theme={style}
        showModal={showModal}
        toggleModal={toggleModal}
        disableScroll={disableScroll}
      />
      <HeroBackground theme={style} {...backgroundProps}>
        <Overlay theme={style}>
          <Logo theme={style} isSeries={backgroundProps?.isSeries} {...logoProps} />
          <Headline theme={style} text={title} />
          <Description
            theme={style}
            {...descriptionProps}
            toggleModal={toggleModal}
            disableScroll={disableScroll}
          />
          <Metadata theme={style} {...metaData} />
          <ProgressBar {...progressProps} theme={style} />
          <ActionButtons buttons={buttonArray} theme={style}>
            <Favorite {...favoriteData} theme={style} />
          </ActionButtons>
        </Overlay>
      </HeroBackground>
    </>
  );
};

Series.propTypes = {
  account: PropTypes.shape({}),
  analytics: PropTypes.shape({}).isRequired,
  bookmarks: PropTypes.shape({}),
  continueWatchingItems: PropTypes.shape({}),
  disableScroll: PropTypes.func,
  favoriteProps: PropTypes.shape({}),
  item: PropTypes.shape({}),
};

export default Series;
